import React from 'react';
var defaultBreakpoints = { s: 336, m: 560, l: 1080, xl: 1464 };
var BreakpointsContext = React.createContext(defaultBreakpoints);
var BreakpointsProvider = BreakpointsContext.Provider, BreakpointsConsumer = BreakpointsContext.Consumer;
var useBreakpoints = function () {
    return React.useContext(BreakpointsContext);
};
/** Receives 'breakpoints' object via render props from `Breakpoints` component
 * @param {object} breakpoints object containing breakpoints
 *
 * @property {number} breakpoints.s - small breakpoint (units are px)
 * @property {number} breakpoints.m - medium breakpoint (units are px)
 * @property {number} breakpoints.l - large breakpoint (units are px)
 * @property {number} breakpoints.xl - extra large breakpoint (units are px)
 *
 * @property {boolean} breakpoints.isDefaultSize - window width is smaller than 's' breakpoint
 * @property {boolean} breakpoints.isS - window width is between 's' and 'm' breakpoints
 * @property {boolean} breakpoints.isM - window width is between 'm' and 'l' breakpoints
 * @property {boolean} breakpoints.isL - window width is between 'l' and 'xl breakpoint
 * @property {boolean} breakpoints.isXL - window width is greater than 'xl' breakpoint
 *
 * @property {number} breakpoints.heightWindow - innerHeight of window (units are px)
 * @property {number} breakpoints.widthWindow - innerWidth of window (units are px)
 *
 * @property {number} breakpoints.heightScreen - height of the physical screen (units are px, not available in all browsers)
 * @property {number} breakpoints.widthScreen - width of the physical screen (units are px, not available in all browsers)
 *
 * @property {boolean} breakpoints.landscapeWindow - height to width ratio of window is horizontal
 * @property {boolean} breakpoints.portraitWindow - height to width ratio of window is vertical
 *
 * @property {boolean} breakpoints.landscapeScreen - orientation of physical screen is horizontal (not available for all browsers)
 * @property {boolean} breakpoints.portraitScreen - orientation of physical screen is vertical (not available for all browsers)*/
export { BreakpointsProvider, BreakpointsConsumer, BreakpointsContext, defaultBreakpoints, useBreakpoints };
